export default {
      id: "get-quote-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#get-quote",
      toString: function () {
        return this.url;
      }
    }